<div class="breadcrumb_outer">
    <ul class="breadcrumb">
      <li class="active"><a>Site Maintenance</a></li>
    </ul>
    <div class="right">
      <span>{{currentTime}}</span>
    </div>
</div>
<div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class ="main_outer">
  <div class="site_maintenance">
    <div class="left" style="margin-left: 50px;">
      <h4>Schedule Maintenance</h4>
    </div>
    <div class="right">
      <button mat-raised-button color="primary" (click)="openScheduleForm()">
        <span class="sprite_icon plus_white"></span>
        <span>Add Schedule</span>
      </button>
    </div>
  </div>


    <div class="no_result" *ngIf="showEmptyError != ''">
        <p
          style="font-size: 16px; color: #838383; text-align: center; padding: 30px"
        >
          {{ showEmptyError }}
        </p>
    </div>
    <div id="schedule-list" *ngIf="showEmptyError == ''">
        <div class="asset_list_view_outer">
        <div class="list_view_outer">
          <div class="table-responsive" style="width: 99%; margin-top: 10px; margin-left: 10px;">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Publish Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let log of maintenanceLogList; let idx = index"
                >
                  <!-- <tr *ngFor="let report of reportDataArr| searchfilter: searchText;let idx = index; "> -->
                  <td class="txt-color">{{ log?.title || "N/A" }}</td>
                  <td>{{ log?.description || "N/A" }}</td>
                  <td>{{ log?.start_date || "N/A" }}</td>
                  <td>{{ log?.end_date || "N/A" }}</td>
                  <td>{{ log?.publish_date || "N/A" }}</td>
                  <td class="text-right">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="editScheduleLog(log)"
                    >
                      <span>Edit</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
    </div>
  </div>

</div>
